import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useTopUpUIContext } from "./TopUpUIContext";
import TopUpTable from "./topup-table/TopUpTable";
import { TopUpForm } from "./topup-form/TopUpForm";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchOrganization } from "../../Organization/_redux/organization/organizationAction";
import InvoiceListTable from "./invoice-list/InvoiceListTable";
import { createTopUpInvoice, fetchTopUps } from "../_redux/topUpAction";

export const TopUpCard = ({ history }) => {
  const [totalTax, setTotalTax] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0);

  // Billing UI Context
  const topupUIContext = useTopUpUIContext();
  const topupUIProps = useMemo(() => {
    return {
      setQueryParams: topupUIContext.setQueryParams,
      queryParams: topupUIContext.queryParams,
    };
  }, [topupUIContext]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchOrganization());
    dispatch(fetchTopUps(topupUIProps.queryParams));
  }, [topupUIProps.queryParams]);

  const { actionsLoading, organizationForEdit = {} } = useSelector(
    (state) => ({
      actionsLoading: state.organizations.actionsLoading,
      organizationForEdit: state.organizations.organizationForEdit,
      isLetter: state.organizations.is_letter,
      error: state.organizations.error,
    }),
    shallowEqual
  );

  const { currentState } = useSelector(
    (state) => ({ currentState: state.topUp }),
    shallowEqual
  );

  const {
    invoiceTopUpInvoiceList = [],
    totalCount,
    listLoading,
  } = currentState;

  const [invoiceData, setInvoiceData] = useState([]);

  const applyTopUp = (values) => {
    let array = [];
    for (const key in values) {
      let total;
      let itemPrice;
      switch (key) {
        case "email":
          total = values[key] * organizationForEdit.plan.price_email;
          itemPrice = organizationForEdit.plan.price_email;
          break;
        case "sms":
          total = values[key] * organizationForEdit.plan.price_sms;
          itemPrice = organizationForEdit.plan.price_sms;
          break;
        case "wa":
          total = values[key] * organizationForEdit.plan.price_wa;
          itemPrice = organizationForEdit.plan.price_wa;
          break;

        default:
          total = "";
          itemPrice = "";
          break;
      }
      array.push({
        item: key.toUpperCase(),
        qty: values[key],
        price: itemPrice,
        total_price: total,
      });
    }
    setInvoiceData(array);
  };

  const createInvoice = () => {
    const data = {
      plan_uuid: organizationForEdit.plan_uuid,
      sub_total: subTotal,
      tax: totalTax,
      total: grandTotal,
      invoice_items: invoiceData,
    };
    dispatch(createTopUpInvoice(data)).then((res) => {
      history.push(`/billing/top-up/${res.data.uuid}/invoice`);
    });
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader title="TopUp"></CardHeader>
        <CardBody>
          <TopUpForm applyTopUp={applyTopUp} />
        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Invoice" />
        <CardBody>
          <TopUpTable
            invoiceData={invoiceData}
            setGrandTotal={(val) => setGrandTotal(val)}
            setSubTotal={(val) => setSubTotal(val)}
            setTotalTax={(val) => setTotalTax(val)}
            grandTotal={grandTotal}
            subTotal={subTotal}
            totalTax={totalTax}
            createInvoice={createInvoice}
          />
        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Daftar Invoice" />
        <CardBody>
          <InvoiceListTable
            invoiceData={invoiceTopUpInvoiceList}
            queryParams={topupUIProps.queryParams}
            setQueryParams={topupUIProps.setQueryParams}
            totalCount={totalCount}
            listLoading={listLoading}
            history={history}
          />
        </CardBody>
      </Card>
    </>
  );
};
